import { gql } from "@apollo/client/core";
const navQuery = gql`
  {
    categories {
      name
    }
    currencies {
      label
      symbol
    }
  }
`;
export default navQuery;
